import{createContext as a}from'react';const o=a({addToast:()=>{throw new Error('To add a toast, wrap the app in a ToastHandler.')}});export{o as ToastContext};
